import React from 'react'
import ImageGallery from 'react-image-gallery'
import StatelessFuncToPureComponent from './StatelessFuncToPureComponent'

const Carousel = ({images}) => {
  const imgs = images.map((url) => {return {original: url}})
  const onClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }
  return <div onClick={onClick}>
    <ImageGallery
      items={imgs}
      showThumbnails={false}
      lazyLoad={false}
      showBullets={true}/>
  </div>
}
export default StatelessFuncToPureComponent(Carousel)



/** WEBPACK FOOTER **
 ** ./app/components/Carousel.jsx
 **/